import { parseDate } from './dateUtils';

const startTime = (service) => {
	const date = parseDate(service?.scheduledDate);
	return date ? date.getTime() : Number.POSITIVE_INFINITY;
};

/**
 * Records a saved reschedule against the grouped work order data.
 *
 * The Gantt already shows the bar where it was dropped, and rebuilding the
 * task list would re-initialise it and shift the view. The record is patched
 * in place, without touching the list identity, so later rebuilds (more work
 * orders paging in) carry the saved date.
 */
export const applyServiceScheduledDate = (groups, serviceId, scheduledDate) => {
	if (!Array.isArray(groups)) return false;

	for (const group of groups) {
		const service = group?.services?.find?.((item) => item?.id === serviceId);
		if (service) {
			service.scheduledDate = scheduledDate;
			return true;
		}
	}

	return false;
};

// A service left without a date has nowhere to sit on the timeline, so it goes to the bottom
export const sortServicesByScheduledDate = (services) => {
	if (!Array.isArray(services)) return [];

	return [...services].sort(
		(first, second) => startTime(first) - startTime(second),
	);
};
